module.exports = __webpack_public_path__ + "fonts/licensed/tenon-italic.woff";